/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Additionallocation1Inputs */

const en_additionallocation1 = /** @type {(inputs: Additionallocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional Location`)
};

const de_additionallocation1 = /** @type {(inputs: Additionallocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiterer Ort`)
};

/**
* | output |
* | --- |
* | "Additional Location" |
*
* @param {Additionallocation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const additionallocation1 = /** @type {((inputs?: Additionallocation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Additionallocation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_additionallocation1(inputs)
	return de_additionallocation1(inputs)
});
export { additionallocation1 as "additionalLocation" }